import type { RecipeVariantProps } from '@chakra-ui/react';
import { defineSlotRecipe } from '@chakra-ui/react';

// todo cover.lv remove this after new agent card is released
export const agentCard = defineSlotRecipe({
  slots: [
    'body',
    'cardContainer',
    'cardBody',
    'shadow',
    'divider',
    'ticker',
    'avatarContainer',
    'avatarBody',
  ],
  base: {
    avatarContainer: {
      rounded: 'full',
    },
    cardBody: {
      position: 'relative',
      borderRadius: 'inherit',
    },
  },
  variants: {
    variant: {
      special: {
        root: {
          '--avatar-size': '12px',
        },
        body: {},
        cardContainer: {
          position: 'relative',
          padding: '2px',
          background:
            'var(--Cara-gradient, linear-gradient(90deg, #31E2E8 0%, #138DFF 100%))',
          boxShadow: '4px 4px 0px 0px #31E2E8',
        },
        cardBody: {
          bgColor: '#D6F0F9',
        },
        divider: {
          display: 'block',
          bg: 'var(--Cara-gradient, linear-gradient(90deg, #31E2E8 0%, #138DFF 100%))',
          base: {
            w: 'full',
            h: '1px',
          },
          desktop: {
            w: '1px',
            h: 'initial',
          },
        },
        ticker: {
          background:
            'var(--Cara-gradient, linear-gradient(90deg, #31E2E8 0%, #138DFF 100%))',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        },
        avatarContainer: {
          position: 'relative',
          padding: '2px',
          background:
            'var(--Cara-gradient, linear-gradient(90deg, #31E2E8 0%, #138DFF 100%))',
        },
      },
      default: {
        body: {
          borderRadius: '10px',
          boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
        },
        cardContainer: {
          rounded: '12px',
          position: 'relative',
          borderWidth: '2px',
          borderColor: 'text.default',
          boxShadow: '4px 4px 0px 0px {colors.secondary.orange}',
        },
        cardBody: {
          bgColor: 'background.offWhite',
        },
        shadow: {
          boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
        },
        divider: {
          base: {
            w: 'full',
            h: '1px',
          },
          desktop: {
            w: '1px',
            h: 'initial',
          },
          bgColor: 'secondary.orange',
        },
        ticker: {},
        avatarContainer: {
          borderWidth: '2px',
          borderColor: 'text.default',
        },
      },
    },
  },
  compoundVariants: [],
  defaultVariants: {
    variant: 'default',
  },
});

export type AgentCardVariantProps = RecipeVariantProps<typeof agentCard>;
